"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-094d248a"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "main-settings-container" };
const _hoisted_2 = {
    key: 0,
    class: "upgrade-message-overlay"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "upgrade-message-card text-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "modal-title h4" }, "アップグレードが必要です"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "この機能を使用するためには"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "pro-label chat-label m-2" }),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "プランへアップグレードが必要です")
], -1 /* HOISTED */));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = {
    key: 1,
    class: "settings-card-container"
};
const _hoisted_6 = { class: "settings-title-wrapper" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "チャット", -1 /* HOISTED */));
const _hoisted_8 = { class: "settings-item" };
const _hoisted_9 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "ルーム", -1 /* HOISTED */));
const _hoisted_11 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフがルーム作成をできなくする")
], -1 /* HOISTED */));
const _hoisted_13 = { class: "settings-input oplus-form-switch" };
const _hoisted_14 = ["checked"];
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_16 = { class: "settings-item" };
const _hoisted_17 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "ルーム", -1 /* HOISTED */));
const _hoisted_19 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "管理者は、所属拠点に関係なく、全拠点のスタッフをルームに追加できます。")
], -1 /* HOISTED */));
const _hoisted_21 = { class: "settings-input oplus-form-switch" };
const _hoisted_22 = ["checked"];
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_24 = { class: "settings-item" };
const _hoisted_25 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "メッセージ", -1 /* HOISTED */));
const _hoisted_27 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフがメッセージにファイルを添付・送信できないようにする")
], -1 /* HOISTED */));
const _hoisted_29 = { class: "settings-input oplus-form-switch" };
const _hoisted_30 = ["checked"];
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_32 = {
    key: 2,
    class: "loading"
};
const _hoisted_33 = {
    key: 3,
    class: "submit"
};
const vue_3 = require("vue");
const OplusChatIcon_vue_1 = __importDefault(require("../../assets/icons/OplusChatIcon.vue"));
const AlertModal_vue_1 = __importDefault(require("../../../vue/AlertModal.vue"));
const provider_1 = require("../../../provider/provider");
const InfoIcon_vue_1 = __importDefault(require("../../../vue/icons/InfoIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ChatSettings',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.chatSettingsViewModelInjectKey);
        const controller = (0, vue_3.inject)(provider_1.chatSettingsControllerInjectKey);
        const alertModal = (0, vue_3.ref)(null);
        const blockStaffCheck = (0, vue_3.ref)(null);
        const blockStaffFileAttachmentCheckbox = (0, vue_3.ref)(null);
        const allowMembershipForStaffOutsideBranchCheck = (0, vue_3.ref)(null);
        (0, vue_3.onMounted)(async () => {
            if (!viewModel || !controller) {
                alert('Required injections not found.');
                return;
            }
            if (viewModel.value.settings) {
                return;
            }
            await controller.getChatSettings(viewModel.value.id);
        });
        const showSettings = (0, vue_3.computed)(() => {
            return viewModel?.value.showSettings || false;
        });
        const showUpgradeMessage = (0, vue_3.computed)(() => {
            return viewModel?.value.showUpgradeMessage ?? true;
        });
        const blockStaffChecked = (0, vue_3.computed)(() => {
            return viewModel?.value.settings?.blockStaffRoomCreation ?? false;
        });
        const allowMembershipForStaffOutsideBranchChecked = (0, vue_3.computed)(() => {
            return viewModel?.value.settings?.allowMembershipForStaffOutsideBranch ?? false;
        });
        const blockStaffFileAttachmentChecked = (0, vue_3.computed)(() => {
            return viewModel?.value.settings?.blockStaffFileAttachment ?? false;
        });
        const isLoading = (0, vue_3.ref)(false);
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": isLoading.value,
            };
        });
        async function handleSubmit() {
            if (isLoading.value || !controller || !viewModel || viewModel.value.showUpgradeMessage) {
                return;
            }
            const body = {
                blockStaffRoomCreation: blockStaffCheck.value?.checked,
                allowMembershipForStaffOutsideBranch: allowMembershipForStaffOutsideBranchCheck.value?.checked,
                blockStaffFileAttachment: blockStaffFileAttachmentCheckbox.value?.checked,
            };
            try {
                isLoading.value = true;
                await controller.patchChatSettings(viewModel.value.id, body);
                alertModal.value?.alertSuccess("設定を更新しました！");
            }
            catch (e) {
                alertModal.value?.alert(e);
            }
            finally {
                isLoading.value = false;
            }
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(AlertModal_vue_1.default, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, null, 512 /* NEED_PATCH */),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (showUpgradeMessage.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, _hoisted_4))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (showSettings.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (0, vue_2.createVNode)(OplusChatIcon_vue_1.default),
                                _hoisted_7
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                    _hoisted_10,
                                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_12
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_13, [
                                    (0, vue_2.createElementVNode)("input", {
                                        ref_key: "blockStaffCheck",
                                        ref: blockStaffCheck,
                                        checked: blockStaffChecked.value,
                                        type: "checkbox"
                                    }, null, 8 /* PROPS */, _hoisted_14),
                                    _hoisted_15
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                    _hoisted_18,
                                    (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_20
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_21, [
                                    (0, vue_2.createElementVNode)("input", {
                                        ref_key: "allowMembershipForStaffOutsideBranchCheck",
                                        ref: allowMembershipForStaffOutsideBranchCheck,
                                        checked: allowMembershipForStaffOutsideBranchChecked.value,
                                        type: "checkbox"
                                    }, null, 8 /* PROPS */, _hoisted_22),
                                    _hoisted_23
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                (0, vue_2.createElementVNode)("div", _hoisted_25, [
                                    _hoisted_26,
                                    (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_28
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_29, [
                                    (0, vue_2.createElementVNode)("input", {
                                        ref_key: "blockStaffFileAttachmentCheckbox",
                                        ref: blockStaffFileAttachmentCheckbox,
                                        checked: blockStaffFileAttachmentChecked.value,
                                        type: "checkbox"
                                    }, null, 8 /* PROPS */, _hoisted_30),
                                    _hoisted_31
                                ])
                            ])
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_32, " loading... ")),
                    (showSettings.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_33, [
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", loadingClass.value]),
                                onClick: handleSubmit
                            }, "確定", 2 /* CLASS */)
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
